import { Component, OnInit } from '@angular/core';
import DynamicFormDTO from '../../../dynamic-form-v2/dtos/DynamicFormDTO';

@Component({
  selector: 'app-base-dynamic-view',
  templateUrl: './base-dynamic-view.component.html'
})
/**
 * Base Dynamic View Component
 */
export class BaseDynamicViewComponent<C = undefined, F = undefined> implements OnInit
{
  title: string = "";
  isLoading: boolean = true;
  fields:  Array<DynamicFormDTO<C, F>> = [];
  sidebarFields:  Array<DynamicFormDTO<C, F>> = [];
  layout: string = 'full-screen';
  entityType: string;
  hideEnabledField: boolean = false;
  viewRoute: string;

  constructor() { }

  /**
   * Base Dynamic View Component Initialization
   */
  ngOnInit()
  {
  }
}
